"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import { createClient } from "@/lib/supabase/client";
import { trackCTA } from "@/lib/analytics";
import { Logo } from "@/components/ui/logo";

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const supabase = createClient();
    supabase.auth.getUser().then(({ data: { user } }) => {
      setIsLoggedIn(!!user);
    });
  }, []);

  return (
    <header className="sticky top-0 z-50 border-b-2 border-border-thick bg-warm-white shadow-brutal-sm">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <Logo size={36} />
          <h2 className="text-2xl font-bold tracking-tight font-display">SnapCards</h2>
        </div>
        <nav className="hidden md:flex items-center gap-8">
          <a className="text-sm font-bold hover:text-primary hover:underline decoration-2 underline-offset-4" href="#how-it-works">How it works</a>
          <a className="text-sm font-bold hover:text-primary hover:underline decoration-2 underline-offset-4" href="#features">Features</a>
          <a className="text-sm font-bold hover:text-primary hover:underline decoration-2 underline-offset-4" href="#pricing">Pricing</a>
          <a className="text-sm font-bold hover:text-primary hover:underline decoration-2 underline-offset-4" href="#faq">FAQ</a>
        </nav>
        <div className="flex items-center gap-4">
          {isLoggedIn ? (
            <Link href="/dashboard" className="hidden md:flex h-10 items-center justify-center rounded-lg border-2 border-border-thick bg-safety-orange px-6 font-bold font-display shadow-brutal-sm transition-transform active:translate-x-[2px] active:translate-y-[2px] active:shadow-none hover:bg-safety-orange/90">
              Dashboard
            </Link>
          ) : (
            <>
              <Link className="font-bold text-sm hover:text-primary hidden md:block" href="/login">Log In</Link>
              <Link href="/login" onClick={() => trackCTA("header")} className="hidden md:flex h-10 items-center justify-center rounded-lg border-2 border-border-thick bg-safety-orange px-6 font-bold font-display shadow-brutal-sm transition-transform active:translate-x-[2px] active:translate-y-[2px] active:shadow-none hover:bg-safety-orange/90">
                Make Cards
              </Link>
            </>
          )}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden flex h-11 w-11 items-center justify-center rounded-lg border-2 border-border-thick bg-white shadow-brutal-sm active:translate-x-[2px] active:translate-y-[2px] active:shadow-none cursor-pointer"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {menuOpen ? (
                <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
              ) : (
                <><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="18" x2="20" y2="18"/></>
              )}
            </svg>
          </button>
        </div>
      </div>
      {menuOpen && (
        <nav className="md:hidden border-t-2 border-border-thick bg-warm-white">
          <div className="flex flex-col px-6 py-4 gap-2">
            <a onClick={() => setMenuOpen(false)} className="px-4 py-3 text-base font-bold rounded-lg hover:bg-white" href="#how-it-works">How it works</a>
            <a onClick={() => setMenuOpen(false)} className="px-4 py-3 text-base font-bold rounded-lg hover:bg-white" href="#features">Features</a>
            <a onClick={() => setMenuOpen(false)} className="px-4 py-3 text-base font-bold rounded-lg hover:bg-white" href="#pricing">Pricing</a>
            <a onClick={() => setMenuOpen(false)} className="px-4 py-3 text-base font-bold rounded-lg hover:bg-white" href="#faq">FAQ</a>
            <div className="border-t-2 border-border-thick mt-2 pt-4">
              <Link href={isLoggedIn ? "/dashboard" : "/login"} onClick={() => !isLoggedIn && trackCTA("header-mobile")} className="w-full flex h-12 items-center justify-center rounded-lg border-2 border-border-thick bg-safety-orange px-6 font-bold font-display shadow-brutal-sm">
                {isLoggedIn ? "Dashboard" : "Make Cards"}
              </Link>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
}
